// extracted by mini-css-extract-plugin
module.exports = {"head":"Header_head__1yP1Q"};